import * as React from 'react';
import Layout from '../layout';
import { Safari, Text, Title, SubtitleMobile, ButtonMobile, RecordWrapper, ListModules, WebcamWrapper, RecordHeader, StepNumber, ActionsWrapper, ModuleListItem, ModuleContainer, OnDesktop, OnMobile} from './styled';
import { Link, useHistory } from 'react-router-dom';


import { Button } from '../../widgets/globaleStyledWidget';
import { colors, lang } from '../../variables';


import 'video.js/dist/video-js.css';
import videojs from 'video.js';

import 'webrtc-adapter';
import RecordRTC from 'recordrtc';

import 'videojs-record/dist/css/videojs.record.css';
import 'videojs-record/dist/videojs.record.js';
import livstickApp from '../../models/livstick';

import {FormattedMessage} from 'react-intl';
import manifest from '../../manifest';
import { events } from '../../events';


const RecordPage:React.FunctionComponent = () => {

  const [moduleIndex, setModuleIndex] = React.useState<number>(0);
  const [playerState, setPlayerState] = React.useState<number>(0);
  const [player, setPlayer] = React.useState<any>(null);

  const history = useHistory();
  
  const openModule = (index: number) => {
    setModuleIndex(index);
  }

  const videoEl = React.useRef(null);
  const fileEl = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    
    console.log('ref', videoEl);
    window.innerWidth < 747 ? livstickApp.postEvent(events.player_b) : livstickApp.postEvent(events.player_a);

    fileEl.current.addEventListener('change', (e) => {
      livstickApp.videoFile = fileEl.current.files[0];
      history.push('message');
    })
    
  }, [])

  const startRecord = () => {
  
    livstickApp.postEvent(events.player_e);

    livstickApp.code = manifest.CODE_AUTO_CODE;
    player.record().start();
    setPlayerState(1);
  }

  const uploadFile = () => {
    livstickApp.postEvent(events.player_i);
    fileEl.current.click();
  }
  const readRecord = () => {
    setPlayerState(3)
    player.play();
  }

  const validate = () => {
    livstickApp.postEvent(events.player_v)
    history.push('message')
  }

  return <Layout>
    <RecordWrapper>
      <RecordHeader>
      </RecordHeader>
      <ModuleContainer>
        <input type="file" style={{display: 'none'}} ref={fileEl} accept="video/*"/>
        <div>
          <OnDesktop>
            <Safari>
              <StepNumber className="step"><FormattedMessage id="global_txt_step"/> 1/2</StepNumber>
              <Title><FormattedMessage id="player_txt_safari_title" /></Title>
              <Text><FormattedMessage id="player_txt_safari" /></Text>
              <ActionsWrapper>
                {/*ROMAIN CHANGEMENT BUTTON*/}{[0].includes(playerState) && <Button className="button-mobile" color={colors.secondary} hover="secondary" onClick={uploadFile}><FormattedMessage id="player_txt_button_import"/></Button>}
                {/*ROMAIN CHANGEMENT BUTTON*/}{[3].includes(playerState) && <Button className="button-mobile" color={colors.secondary} hover="secondary" onClick={validate}><FormattedMessage id="player_txt_button_send"/></Button>}
              </ActionsWrapper>
            </Safari>
          </OnDesktop>
          <OnMobile>
            <StepNumber><FormattedMessage id="global_txt_step"/> 1/2</StepNumber>
            <SubtitleMobile><FormattedMessage id="player_txt_title" /></SubtitleMobile>
            {[0].includes(playerState) && <ButtonMobile className="button-mobile button-special" onClick={uploadFile}><FormattedMessage id="player_txt_video_button" /></ButtonMobile>}
          </OnMobile> 
        </div>
      </ModuleContainer>
      
    </RecordWrapper>
    
  </Layout>
}

export default RecordPage;